module.exports = "\n<div class=\"content-loader\" [hidden]=\"status != 'loading'\">\n    <itpx-spinner></itpx-spinner>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/consumption-redirect/consumption-redirect.component.html
// module id = 929
// module chunks = 0